export const storageKeys = {
  codeVerifier: "workos:code-verifier",
  user: "workos:user",
  accessToken: "workos:access-token",
  refreshToken: "workos:refresh-token",
  expiresAt: "workos:expires-at",
  authenticationMethod: "workos:authentication-method",
} as const;
